/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ failed: NonNullable<unknown>, total: NonNullable<unknown> }} Rights_Remove_PartialInputs */



/**
* | output |
* | --- |
* | "{failed} of {total} overrides could not be removed." |
*
* @param {Rights_Remove_PartialInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_remove_partial = /** @type {((inputs: Rights_Remove_PartialInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Remove_PartialInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.failed} von ${i?.total} Ausnahmen konnten nicht entfernt werden.`)
	return /** @type {LocalizedString} */ (`${i?.failed} of ${i?.total} overrides could not be removed.`)
});